import { ComponentAPI } from '@philips-emr/tws-core';

class SuperscriptionAPI extends ComponentAPI {
  getColor(): string {
    return this.state.color;
  }

  setColor(color: string): void {
    this.setState({ color });
  }

  getLabel(): string {
    return this.state.label;
  }

  setLabel(label: string): void {
    this.setState({ label });
  }

  isShowLabel(): boolean {
    return this.state.showLabel;
  }

  setShowLabel(showLabel: boolean): void {
    this.setState({ showLabel });
  }

  getValue(): string {
    return this.state.value;
  }

  setValue(value: string): void {
    this.setState({ string: value });
  }
}

export default SuperscriptionAPI;
